import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "@mui/material";
import { forwardRef } from "react";
export const UiContainer = forwardRef((props, ref) => (_jsx(Container, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_container.js.map